<div class="home home-page">
  <section>
    <section class="bg-cover bg-menu-scholarship-info"></section>

    <div class="content-wrapper">
      <iframe [src]="iframeUrl" height="700px" width="100%"></iframe>
    </div>
  </section>
</div>
